<template>
<div>
    <pt-sub-title title="问答相关信息"></pt-sub-title>
    <table :class="$style['obs-question-message']">
         <pt-message-table-item label="签约产科问答">
             {{joinObstetricsQA?'是':'否'}}
         </pt-message-table-item>
         <template v-if="joinObstetricsQA">
         <pt-message-table-item label="医生头像">
             <pt-img @click.native="onPreview(data.idPhoto)" v-if="data.idPhoto" :class="$style['picture-radius']"
             :src="data.idPhoto" ></pt-img>
         </pt-message-table-item>
         <pt-message-table-item label="产科问答医院">
           {{data.qaHospitals&&data.qaHospitals[0]&&data.qaHospitals[0].name}}
         </pt-message-table-item>
         <pt-message-table-item label="医生擅长">
             {{data.excellent}}
         </pt-message-table-item>
         <pt-message-table-item label="医生简介">
             {{data.introduction}}
         </pt-message-table-item>
         <pt-message-table-item label="是否消费积分">
             {{(data.qaExtendInfo&&data.qaExtendInfo.needPoints)?'是':'否'}}
         </pt-message-table-item>
         <pt-message-table-item label="提问分值">
            <table v-if="data.qaExtendInfo&&data.qaExtendInfo.memberConfigure&&data.qaExtendInfo.memberConfigure.length">
                <tr>
                    <td>允许提问</td>
                    <td class="integral-goods-of-leval">等级</td>
                    <td>分值</td>
                </tr>
                <tr v-for="(item,index) in data.qaExtendInfo.memberConfigure" :key="index">
                    <td>{{item.allowQuestions?'是':'否'}}</td>
                    <td class="integral-goods-of-leval">{{item.name}}</td>
                    <td>{{item.points}}</td>
                </tr>
         </table>
         </pt-message-table-item>
         </template>
    </table>
    <wt-image-preview v-if="previewVisible" @close-preview="closePreview" :value="images" :initial-index="currentIndex" :loop="false"></wt-image-preview>
</div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      images: '',
      previewVisible: false,
      currentIndex: 1
    }
  },
  computed: {
    joinObstetricsQA () {
      return this.data.joinObstetricsQA === 'true' || this.data.joinObstetricsQA === true
    }
  },
  methods: {
    onPreview (img) {
      this.images = this.privateImg + img
      this.previewVisible = true
    },
    closePreview () {

    }
  }
}
</script>
<style module lang="less">

.picture-radius{
    border-radius:5px;
    justify-content: flex-start!important;
    max-width: 100px;
}
.obs-question-message{
    padding: 0 20px;
    :global{
         .integral-goods-of-leval{
      padding:0 20px
    }
    }
}
</style>
